import { Typography } from '@mui/material'
import React from 'react'
import InputField from '../../../../../../../FormControl/input/InputField'
import { useByStudent } from '../../../ByStudentContext/ByStudentContext'

const FormLcElements = ({ form = {}, onChange }) => {
  const {
    currentCurriculum,
  } = useByStudent();

  if (!currentCurriculum || !currentCurriculum?.lcElements?.children) return <></>
  return (
    <>
      {currentCurriculum?.lcElements?.children
        .sort((a, b) => a.position - b.position)
        .map((item) => (
        <React.Fragment key={item._id}>
          <div>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              {item?.name}
            </Typography>
          </div>
          <div className='col-span-3'>
            <InputField
              id={`${item?._id}`}
              name={item?._id}     
              className='capitalize'
              value={form[item?._id]}
              onChange={(e) => onChange(item?._id, item?.name, e.target.value)}      
            />
          </div>
        </React.Fragment>
      ))}
    </>
  )
}

export default FormLcElements